import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { NumberFormat } from 'components/Elements'

import { Table } from '../Table'

export const EmployersBlock = ({ data = {} }) => {
  const { t } = useTranslation()

  const { period, total } = data

  const items = [
    {
      label: t('amount'),
      Cell: () => <NumberFormat value={period} />,
    },
    {
      label: t('total_amount'),
      Cell: () => <NumberFormat value={total} />,
    },
  ]

  return (
    <>
      <h4 className="font-size-18">{t('employers')}</h4>

      <Table items={items} />
    </>
  )
}

EmployersBlock.propTypes = {
  data: PropTypes.object,
}
